import React, { useContext } from "react";
import { DataComplaintContext } from "../../Complaints/types";
import { InputElementComplaint } from "./InputElementComplaint";
import { useTranslation } from "react-i18next";
import { InputImage } from "../../../HtmlComponents/InputImage";
import { hostName } from "../../../requestMethods";
import { TextAreaElement } from "../../../HtmlComponents/TextAreaElement";

const InputsComplaintFront: React.FC = () => {
  const {
    fullName, setFullName,
    phone, setPhone,
    RegNo, setRegNo,
    cabinetName, setCabinetName,
    doctorName, setDoctorName,
    devis, setDevis,
    message, setMessage,
  } = useContext(DataComplaintContext);
  const { t } = useTranslation()

  return (<>
    <InputElementComplaint
      type="text"
      name={t("Nom")}
      placeholder={t("Nom du patient")}
      id="fullName"
      value={fullName}
      setValue={setFullName}
    />
    <InputElementComplaint
      type="text"
      name={t("Telephone")}
      id={t("Donnez votre numéro de téléphone")}
      value={phone}
      setValue={setPhone}
    />
    <InputElementComplaint
      type="text"
      name={t("Matricule")}
      placeholder={t("Donnez votre matricule")}
      id="Matricule"
      value={RegNo}
      setValue={setRegNo}
    />
    <InputElementComplaint
      type="text"
      name={t("Cabinet")}
      placeholder={t("Nom du Cabinet")}
      id="Cabinet"
      value={cabinetName}
      setValue={setCabinetName}
    />
    <InputElementComplaint
      type="text"
      name={t("Docteur")}
      placeholder={t("Nom du Docteur")}
      id="Docteur"
      value={doctorName}
      setValue={setDoctorName}
    />
    <TextAreaElement
      name={t("Plainte")}
      placeholder={t("Écrivez votre plainte contre ce docteur")}
      id="Plainte"
      value={message}
      setValue={setMessage}
    />
    <InputImage name={t("Devis")} setValue={setDevis}/>
    {(devis && (typeof devis === 'string')) && <img className='w-full h-56 col-span-2' src={hostName + "imgs/complaints/" + devis} alt="devisAss" /> }          
    {(devis && (typeof devis !== 'string')) && <img className='w-full h-56 col-span-2' src={URL.createObjectURL(devis)} alt="devisAss" /> }          
  </>);
};

export default InputsComplaintFront;
